module.exports = __webpack_public_path__ + "assets/3.73480a01.png";